/**
 * filterBarStyles — style dùng chung cho các button trong Filter Area.
 *
 * Tách khỏi FilterBar.tsx để file component chỉ export component (giữ boundary
 * React Fast Refresh: file .tsx mix component + non-component sẽ bị full-reload).
 */
import { alpha, type SxProps, type Theme } from '@mui/material/styles'

export const filterBarBtnSx: SxProps<Theme> = (theme) => ({
  minWidth: 0,
  // Mobile compact: button "Search" + "Cols/Columns" giảm padding/font/height
  // tối đa để toolbar fit 1 row + chừa chỗ cho action buttons bên phải.
  px: { xs: 0.35, sm: 0.75 },
  py: { xs: 0.1, sm: 0.2 },
  minHeight: { xs: 20, sm: 26 },
  textTransform: 'none',
  fontSize: { xs: '0.58rem', sm: '0.7rem' },
  lineHeight: 1.05,
  '& .MuiButton-startIcon, & .MuiButton-endIcon': {
    margin: { xs: 0, sm: undefined },
    '& > *:nth-of-type(1)': {
      fontSize: { xs: 12, sm: 16 },
    },
  },
  '&.MuiButton-outlined': {
    borderColor: alpha(theme.palette.text.primary, 0.14),
    '&:hover': {
      borderColor: alpha(theme.palette.text.primary, 0.24),
      backgroundColor: alpha(theme.palette.text.primary, 0.04),
    },
  },
})
